module.exports = __webpack_public_path__ + "img/Hil.1d882da4.png";